import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SiteSettingsContext = createContext(null);

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    company_name: 'Engraveca',
    logo: null,
    loaded: false
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${API_URL}/api/site-settings`);
        if (res.ok) {
          const data = await res.json();
          setSettings({
            ...data,
            loaded: true
          });
        } else {
          setSettings(prev => ({ ...prev, loaded: true }));
        }
      } catch (err) {
        console.error('Failed to fetch site settings:', err);
        setSettings(prev => ({ ...prev, loaded: true }));
      }
    };

    fetchSettings();
  }, []);

  // Helper to get full logo URL
  const getLogoUrl = () => {
    if (settings.logo?.logo_url) {
      return `${API_URL}${settings.logo.logo_url}`;
    }
    return null;
  };

  const getFaviconUrl = () => {
    if (settings.logo?.favicon_url) {
      return `${API_URL}${settings.logo.favicon_url}`;
    }
    return null;
  };

  // Refresh settings (call after upload)
  const refreshSettings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/site-settings`);
      if (res.ok) {
        const data = await res.json();
        setSettings({
          ...data,
          loaded: true
        });
      }
    } catch (err) {
      console.error('Failed to refresh site settings:', err);
    }
  };

  return (
    <SiteSettingsContext.Provider value={{
      settings,
      getLogoUrl,
      getFaviconUrl,
      refreshSettings,
      hasCustomLogo: !!settings.logo?.logo_url,
      hasCustomFavicon: !!settings.logo?.favicon_url
    }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export default SiteSettingsContext;
